<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Form pelanggan baru</h4>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0">
                <div class="row mt-3 p-3 mx-2 bg-white shadow">
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Tipe Pelanggan <span style="color:red;">*</span></label>
                        <smart-select name="client_type" :options="newClientOption.clientTypes" v-on:update="updateClientType"></smart-select>
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">ID Pelanggan <span style="color:red;">*</span></label>
                        <input type="number"  class="form-control w-100 rounded" :min="1" :max="5" v-model="newClient.idKlien" />
                        <small class="text-danger" v-show="isAddIdKlienLength">ID Pelanggan Minimum 3 Digit</small>
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Nama <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.firstName" @input="autoFillLegalName" />
                    </div>
                    <div class="mt-2"  :class="newClientCol" v-if="isNewBadan">
                        <label class="d-block">Nama Belakang</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.lastName" @input="autoFillLegalName" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Nama Legal <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.legalName" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Telp Pemilik</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.telephonePemilik" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Tambah Phone</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.telephoneSecondaryPemilik" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Telp Pemilik (PIC)</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.telephonePengurus" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Email</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.email" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">NPWP</label>
                        <input type="text" id="newNPWP" class="form-control w-100 rounded" v-model="newClient.npwp"  @input="convertNewNPWP" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Identitas Penanggung Jawab</label>
                        <smart-select name="client_identity" :options="newClientOption.identityTypes" v-on:update="updateClientIdentityType"></smart-select>
                    </div>
                    <!-- <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Tipe induk</label>
                        <smart-select name="client_induk" :options="newClientOption.clientTypes" v-on:update="updateClientIndukType"></smart-select>
                    </div> -->
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">No Identitas Penanggung Jawab</label>
                        <input type="number" :min="1" :max="16"  class="form-control w-100 rounded" v-model="newClient.identityNo" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">SIUP</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newClient.siup" />
                    </div>
                    <div class="mt-2" :class="newClientCol">
                        <label class="d-block">Alamat</label>
                        <textarea type="text"  class="form-control w-100 rounded" v-model="newClient.address" />
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewUser">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal menyimpan pelanggan baru.</p>
                                </div>
                                <div v-for="err in errorNewUserList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewPengguna">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewUser">Submit</button>
                    </div>
                </div>
            </div>
            </transition>

        
          

        </div>
    </div>
</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'modal-delete':ModalDelete
        },
        data () {
            return {
                 isMobile:false,

                isAddIdKlienLength:false,
                itemToDelete:{},
                deleteId:0,
                users:[],
                searchValue:'',
                loadData:true,
                savingNewPengguna:false,
                errorNewUser:false,
                errorNewUserList:[],
                existingClientResult:[],
                newUserSaved:false,
                selectedClient:0,
                selectedDetail:0,
                updateUserSaved:false,
                errorUserSaved:false,
                updateUserState:false,
                updateClientSaved:false,
                errorClientSaved:false,
                updateClientState:false,
                failDeleteUser:false,
                isNewBadan:false,
                selectedToDelete:0,
                selectedAdmin:0,
                existingClientQuery:{
                    firstNameClientQuery:'',
                    lastNameClientQuery:'',
                    legalNameClientQuery:'',
                    looking:false,
                    nextQueue:false,
                    waitForNext:false
                },
                newClientCol:'col-4',
                updateClientCol:6,
                updateAdminCol:6,
                selectedTab:0,
                newClient:{
                    idKlien:'',
                    firstName:'',
                    lastName:'',
                    legalName:'',
                    telephonePemilik:'',
                    telephoneSecondaryPemilik:'',
                    telephonePengurus:'',
                    email:'',
                    npwp:'',
                    siup:'',
                    address:'',
                    identity:'KTP',
                    identityNo:'',
                    npwp:'',
                    type:'Badan'
                    // induk:'Badan'
                },
                newClientOption:{
                    identityTypes:[{label:'KTP',value:'KTP'},
                                    {label:'SIM',value:'SIM'},
                                    {label:'Passport',value:'Passport'
                                }],
                    clientTypes:[{label:'Non Perorangan',value:'Badan'},
                                    {label:'Perorangan',value:'Perorangan'
                                }],
                },
                formNewUserActive:false,
                userTableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'No',key:null},
                    {label:'ID Pelanggan',key:null},
                    {label:'Nama',key:null},
                    {label:'Nama Belakang',key:null},
                    {label:'Nama Legal',key:null},
                    {label:'Tindakan',key:null}
                ],
                number:{
                    numberId:5
                }
                // userRoleOptions:[
                //     {label:'Admin',value:'admin'},
                //     {label:'Klien ',value:'client'},
                //     {label:'Supervisor ',value:'Supervisor'},
                // ]
            }
        },
        created(){
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            autoFillLegalName(){
                this.newClient.legalName = this.newClient.firstName +" "+ this.newClient.lastName
                this.users[this.selectedClient].legal_name = this.users[this.selectedClient].first_name +" "+ this.users[this.selectedClient].last_name
            },
            setNPWP(nodata=true,value=""){
                var init = "";
                if(!nodata){
                    init = value
                }
                for(var x=init.length;x<15;x++){
                    init +="0";
                }
                this.newClient.npwp = init.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6');
            },
            convertNewNPWP(){
                var el = document.getElementById('newNPWP');
                this.newClient.npwp=this.newClient.npwp.replace(/\./gi, '');
                this.newClient.npwp=this.newClient.npwp.replace(/\-/gi, '');
                var index = el.selectionStart;
            
                if(index==2||index==6||index==10||index==12||index==16){
                    index++
                }
                console.log(this.newClient.npwp)
                if(this.newClient.npwp.length>0 && this.newClient.npwp.length<15){
                    console.log(this.newClient.npwp.length)
                    for(var x=this.newClient.npwp.length;x<15;x++){
                        
                        this.newClient.npwp +="0";
                    }
                }
                if(this.newClient.npwp.length>15){
                    this.newClient.npwp = this.newClient.npwp.slice(0,15)
                }
                this.newClient.npwp = this.newClient.npwp.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6');
                
                setTimeout(() => {
                    
                    el.focus();
                    el.setSelectionRange(index, index);
                }, 0);
            },
            
            deleteResult(deleted){
                console.log(deleted)
                if(deleted){
                    this.getUsers();
                }
            },
            saveNewUser(){
                this.isAddIdKlienLength=false
                if(this.newClient.idKlien!="" && this.newClient.idKlien.length<3 ){
                    this.isAddIdKlienLength=true
                    return;
                }
                this.savingNewPengguna=true
                this.errorNewUser=false
                if(
                this.newClient.idKlien=='' &&
                this.newClient.firstName=='' &&
                this.newClient.legalName==''
                ){
                    this.errorNewUser = true;
                    this.savingNewPengguna=false;
                    this.errorNewUserList=[]
                    if(this.newClient.idKlien==''){
                        this.errorNewUserList.push(["- Mohon Isi ID Pelanggan"])
                    }
                    if(this.newClient.firstName==''){
                        this.errorNewUserList.push(["- Mohon Isi Nama Pelanggan"])
                    }
                    if(this.newClient.legalName==''){
                        this.errorNewUserList.push(["- Mohon Isi Nama Legal Pelanggan"])
                    }
                    console.log(this.errorNewUserList)
                    return;
                }
                axios.post(this.$baseUrl+'/api/master/klien',
                {
                    customer_id:this.newClient.idKlien,
                    first_name:this.newClient.firstName,
                    last_name:this.newClient.lastName,
                    legal_name:this.newClient.legalName,
                    telephone_pemilik:this.newClient.telephonePemilik,
                    telephone_pemilik_secondary:this.newClient.telephoneSecondaryPemilik,
                    telephone_pengurus:this.newClient.telephonePengurus,
                    email:this.newClient.email,
                    npwp:this.newClient.npwp,
                    siup:this.newClient.siup,
                    address:this.newClient.address,
                    identity:this.newClient.identity,
                    identity_no:this.newClient.identityNo,
                    type:this.newClient.type,
                    // induk:this.newClient.induk,

                },
                {
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    //console.log(result)
                    //console.log(result)
                    this.$emit('createvessel','hello')
                    if(result.data.create){
                        //this.getMastervendors();
                        localStorage.setItem('datavessel',JSON.stringify(result.data))
                    }
                    this.savingNewPengguna=false
                    this.newUserSaved=true

                    setTimeout(() => {
                        this.newUserSaved=false
                        this.formNewUserActive=false
                        window.close()
                    }, 1000);

                }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                    console.log(err.response)
                    this.errorNewUserList=[]
                    this.errorNewUserList=Object.values(err.response.data.errors)
                    console.log(this.errorNewUserList)
                    this.errorNewUser=true
                    this.savingNewPengguna=false
                })
            },
            deleteItem(idx){
                this.selectedToDelete=idx;
            },
            
            updateClientIdentityType(newValue){
                this.newClient.identity=newValue
            },
            updateClientType(newValue){
                this.newClient.type=newValue
                if(newValue=="Perorangan"){
                    this.isNewBadan = true
                }else{
                    this.isNewBadan = false
                }
            },
            updateClientIndukType(newValue){
                this.newClient.induk=newValue
            },
            recallClientSearch(){
                //this.existingClientQuery.waitForNext=true;
                console.log('asign new queue')
                setTimeout(() => {
                    console.log('recall')
                    if(!this.existingClientQuery.looking){
                        this.existingClientQuery.nextQueue=false;
                        this.searchExistingClientChangeEvent();
                    }else{
                        console.log('queue exist, current process still running, retry later')
                        this.recallClientSearch()
                    }
                }, 1000);
            },
            searchExistingClientChangeEvent(){
                if(this.existingClientQuery.looking && !this.existingClientQuery.nextQueue){
                    this.existingClientQuery.nextQueue=true;
                    this.recallClientSearch()
                    return;
                }else if(!this.existingClientQuery.looking && this.existingClientQuery.nextQueue){
                    return;
                }
                
                
                if(this.existingClientQuery.firstNameClientQuery!='' ||  this.existingClientQuery.lastNameClientQuery !="" || this.existingClientQuery.legalNameClientQuery!=''){
                    var data = {
                        first_name:this.existingClientQuery.firstNameClientQuery,
                        last_name:this.existingClientQuery.lastNameClientQuery,
                        legal_name:this.existingClientQuery.legalNameClientQuery,
                    };
                    console.log(data)
                    this.existingClientQuery.looking = true;
                    axios.post(this.$baseUrl+'/api/master/seeker/klien',
                    {
                        first_name:this.existingClientQuery.firstNameClientQuery,
                        last_name:this.existingClientQuery.lastNameClientQuery,
                        legal_name:this.existingClientQuery.legalNameClientQuery,
                    },
                    {
                        'headers':{
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        this.existingClientQuery.looking = false;
                        if(!this.existingClientQuery.nextQueue){
                            console.log('no Queue')
                            this.existingClientResult = result.data;
                        }
                        //console.log(result)
                    }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                        //console.log(err)
                        this.existingClientQuery.nextQueue = false;
                        this.existingClientQuery.looking=false;
                    })
                }else{
                    this.existingClientQuery.looking=false;
                    this.existingClientQuery.nextQueue = false;
                }
            },
            
            
        },
    }
</script>
<style scoped>
.modal.show .modal-dialog{
    transform:none;
    -webkit-transform: none;
}
.btn {
    padding : 5px 10px;
}
::v-deep .modal-content {
    margin: -7.25rem auto;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    width: 50%;
}
</style>


